export default __webpack_public_path__ + "static/media/logo.f80f2e84.png";